import { fetchGet, fetchPost, fetchPatch } from "@/lib/services";

export async function getLeads() {
  return await fetchGet("/mlbwebdataget/");
}

export async function createLeadRemark(data: { Requested_user: number; Remarks: string }) {
  return await fetchPost("/mlbwebdataget/", data);
}

export async function getLeadRemarks(userId: number) {
  return await fetchGet(`/mlbwebdataget/?Request_user=${userId}`);
}

export async function updateLead(id: number, data: {
  Lead_Status_Date: string;
  Lead_Status: number;
  Lead_Status_Remarks: string;
  State: string;
}) {
  return await fetchPatch(`/mlbwebdataget/?Id=${id}`, data);
}
